// 用户信息仓库
import { objectClone } from 'common/tool'
const configinfo = {
  state: {
    ////用户的公共变量仓库  ///使用 this.$store.state.userinfo(子模组，没有时不写).userId（用户变量）
    OneSceneinfo: {
      deleteState: 1,
      followState: null,
      iconId: '',
      iconUrl: '',
      regionId: '',
      regionName: '请选择一个区域',
      sceneId: '',
      sceneName: '',
      sceneNo: null
    },
    OneSceneRuleList: [
      ////获取到的一个场景的规则列表
    ],
    OneSceneRuleObjectRegionList: {
      ///一个场景对应的所有对象及区域的list勾选对应关系
    },
    ServeSceneData: [
      ///服务器传来的所有场景list
    ],
    checkDeviceList: [
      //用户最新的场景设备和组设备的勾选状态  代号 20231207-1  组功能实现
    ],
    // 代号 20231207-1  组功能实现
    OneGroupinfo: {
      deleteState: 1,
      iconId: '',
      iconUrl: '',
      deviceId: '',
      deviceName: '',
      productCode: '',
      productName: '',
      regionId: '',
      regionName: '请选择一个区域',

      followState: null,
      groupNo: null
    },
    OneGroupRuleList: [
      ////获取到的一个场景的规则列表
    ],
    OneGroupRuleObjectRegionList: {
      ///一个场景对应的所有对象及区域的list勾选对应关系
    },
    ServeGroupData: [
      ///服务器传来的所有场景list
    ],

    selectRegionList: [
      //// 子账号页面，控制区域选择，用户提交勾选的区域LIST
    ],
    oneServeSonAccountData: [
      /////一个子账号的信息
    ],
    oneHostData: {
      ////一个主机的信息
    },
    oneHostDeviceListData: {
      ////一个主机下面的设备列表
      offLineList: [],
      onLineList: [],
      threadNewProductList: []
    },
    panelExtensionThirdPanelListData: {
      ////一个面板扩展模块下面的三方面板列表
      extensionProductId: '',
      offLineList: [],
      onLineList: [],
      capacityTotal: 0,
      capacityUsed: 0,
      capacityRemain: 0,
      errorMsg: ''
    },
    ServeOneObjectinfo: {
      //一个对象页面的信息数据
      businessId1: '',
      businessId1Desc: '',
      businessId2: '',
      businessId2Desc: '',
      businessId3: '',
      businessId3Desc: '',
      businessId4: '',
      businessId4Desc: '',
      buttonCode: '',
      buttonId: '',
      buttonName: '',
      deleteState: 1,
      deviceId: '',
      deviceName: '',
      deviceNo: '',
      gatewayId: '',
      gatewayNo: '',
      iconId: '',
      iconSuffix: '',
      iconUrl: '',
      list: [],
      passwordState: '',
      regionId: '',
      regionName: '',
      remark: ''
    },
    serveOneCycTask027Data: {
      ////027插座的一个定时任务数据
    },
    serveOneLoopTask027Data: {
      ///027的一个循环定时任务数据
      closeTime: '',
      createTime: '',
      deviceId: '',
      loopId: '',
      loopNum: 0,
      openTime: '',
      taskStatus: 1
    },
    userPassWord: '', ////用户输入的密码
    CuserPassWord: '', /////用户输入的二次确认密码
    requestSceneTimeout: 5000, ////场景请求的超时时间，根据规则条目数计算得到
    bindHostState: 0, ///0未绑定任何主机设备   1绑定的有主机
    config019PageData: {}, ////019环境探测页面的配置数据
    config023ShowDataText: '自定义', ////019环境探测页面的配置数据
    objectMoveState: false /////界面管理的变量，默认不允许进行拖拽移动变量。
  },
  mutations: {
    ///同步提交信息的方法，组件中的使用 this.$store.commit('updataUserId（定义的方法名）' , '传入的参数')
    updataOneSceneinfo(state, OneSceneinfo) {
      ///深度克隆 保证提交的不是地址
      objectClone(state.OneSceneinfo, OneSceneinfo)
      // state.OneSceneinfo = OneSceneinfo;
    },
    updataOneSceneinfoRegionName(state, OneSceneinfoRegionName) {
      state.OneSceneinfo.regionName = OneSceneinfoRegionName
    },
    updataOneSceneinfoRegionId(state, OneSceneinfoRegionId) {
      state.OneSceneinfo.regionName = OneSceneinfoRegionId
    },

    updataOneSceneRuleList(state, OneSceneRuleList) {
      state.OneSceneRuleList = OneSceneRuleList
    },
    updataOneSceneRuleObjectRegionList(state, OneSceneRuleObjectRegionList) {
      state.OneSceneRuleObjectRegionList = OneSceneRuleObjectRegionList
    },
    updataServeSceneData(state, ServeSceneData) {
      state.ServeSceneData = ServeSceneData
    },
    updataCheckDeviceList(state, CheckDeviceList) {
      state.checkDeviceList = CheckDeviceList
    },
    // 代号 20231207-1  组功能实现
    updataOneGroupinfo(state, OneGroupinfo) {
      ///深度克隆 保证提交的不是地址
      console.log(OneGroupinfo);
      objectClone(state.OneGroupinfo, OneGroupinfo)
      console.log(state.OneGroupinfo);
      // state.OneGroupinfo = OneGroupinfo;
    },
    updataOneGroupinfoRegionName(state, OneGroupinfoRegionName) {
      state.OneGroupinfo.regionName = OneGroupinfoRegionName
    },
    updataOneGroupinfoRegionId(state, OneGroupinfoRegionId) {
      state.OneGroupinfo.regionName = OneGroupinfoRegionId
    },

    updataOneGroupRuleList(state, OneGroupRuleList) {
      state.OneGroupRuleList = OneGroupRuleList
    },
    updataOneGroupRuleObjectRegionList(state, OneGroupRuleObjectRegionList) {
      state.OneGroupRuleObjectRegionList = OneGroupRuleObjectRegionList
    },
    updataServeGroupData(state, ServeGroupData) {
      state.ServeGroupData = ServeGroupData
    },

    //////////////////////////

    updataRequestSceneTimeout(state, requestSceneTimeout) {
      state.requestSceneTimeout = requestSceneTimeout
    },
    updataSelectRegionList(state, selectRegionList) {
      state.selectRegionList = selectRegionList
    },
    updataOneServeSonAccountData(state, oneServeSonAccountData) {
      state.oneServeSonAccountData = oneServeSonAccountData
    },
    updatauserPassWord(state, userPassWord) {
      state.userPassWord = userPassWord
    },
    updataCuserPassWord(state, CuserPassWord) {
      state.CuserPassWord = CuserPassWord
    },
    updataoneHostData(state, oneHostData) {
      state.oneHostData = oneHostData
    },
    updataoneHostDeviceListData(state, oneHostDeviceListData) {
      state.oneHostDeviceListData = oneHostDeviceListData
    },
    updataPanelExtensionThirdPanelListData(state, panelExtensionThirdPanelListData) {
      state.panelExtensionThirdPanelListData = panelExtensionThirdPanelListData
    },
    updataServeOneObjectinfo(state, ServeOneObjectinfo) {
      state.ServeOneObjectinfo = ServeOneObjectinfo
    },
    updataServeOneObjectRegioninfo(state, ServeOneObjectinfo) {
      state.ServeOneObjectinfo.regionName = ServeOneObjectinfo.regionName
      state.ServeOneObjectinfo.regionId = ServeOneObjectinfo.regionId
    },
    updataServeOneObjectIconinfo(state, ServeOneObjectinfo) {
      state.ServeOneObjectinfo.iconId = ServeOneObjectinfo.iconId
      state.ServeOneObjectinfo.iconUrl = ServeOneObjectinfo.iconUrl
    },
    updataserveOneCycTask027Data(state, serveOneCycTask027Data) {
      state.serveOneCycTask027Data = serveOneCycTask027Data
    },
    updataserveOneLoopTask027Data(state, serveOneLoopTask027Data) {
      state.serveOneLoopTask027Data = serveOneLoopTask027Data
    },
    updatabindHostState(state, bindHostState) {
      state.bindHostState = bindHostState
    },
    updataconfig019PageData(state, config019PageData) {
      state.config019PageData = config019PageData
    },
    updataconfig023ShowDataText(state, config023ShowDataText) {
      state.config023ShowDataText = config023ShowDataText
    },
    updataobjectMoveState(state, objectMoveState) {
      state.objectMoveState = objectMoveState
    }
  },
  actions: {
    ////使用方法：this.$store.dispatch('asyUpdataUserId',this.registerSubmitData.telePhone); ///异步提交用户的账号信息到仓库
    asyUpdataOneSceneinfo(context, OneSceneinfo) {
      context.commit('updataOneSceneinfo', OneSceneinfo)
    },
    asyUpdataOneSceneinfoRegionName(context, OneSceneinfoRegionName) {
      context.commit('updataOneSceneinfoRegionName', OneSceneinfoRegionName)
    },
    asyUpdataOneSceneinfoRegionId(context, OneSceneinfoRegionId) {
      context.commit('updataOneSceneinfoRegionId', OneSceneinfoRegionId)
    },
    asyUpdataOneSceneRuleList(context, OneSceneRuleList) {
      context.commit('updataOneSceneRuleList', OneSceneRuleList)
    },
    asyUpdataOneSceneRuleObjectRegionList(
      context,
      OneSceneRuleObjectRegionList
    ) {
      context.commit(
        'updataOneSceneRuleObjectRegionList',
        OneSceneRuleObjectRegionList
      )
    },
    asyUpdataServeSceneData(context, ServeSceneData) {
      context.commit('updataServeSceneData', ServeSceneData)
    },
    asyUpdataCheckDeviceList(context, CheckDeviceList) {
      context.commit('updataCheckDeviceList', CheckDeviceList)
    },

    // 代号 20231207-1  组功能实现
    asyUpdataOneGroupinfo(context, OneGroupinfo) {
      context.commit('updataOneGroupinfo', OneGroupinfo)
    },
    asyUpdataOneGroupinfoRegionName(context, OneGroupinfoRegionName) {
      context.commit('updataOneGroupinfoRegionName', OneGroupinfoRegionName)
    },
    asyUpdataOneGroupinfoRegionId(context, OneGroupinfoRegionId) {
      context.commit('updataOneGroupinfoRegionId', OneGroupinfoRegionId)
    },
    asyUpdataOneGroupRuleList(context, OneGroupRuleList) {
      context.commit('updataOneGroupRuleList', OneGroupRuleList)
    },
    asyUpdataOneGroupRuleObjectRegionList(
      context,
      OneGroupRuleObjectRegionList
    ) {
      context.commit(
        'updataOneGroupRuleObjectRegionList',
        OneGroupRuleObjectRegionList
      )
    },
    asyUpdataServeGroupData(context, ServeGroupData) {
      context.commit('updataServeGroupData', ServeGroupData)
    },
    //////////////////////////

    asyUpdataRequestSceneTimeout(context, requestSceneTimeout) {
      context.commit('updataRequestSceneTimeout', requestSceneTimeout)
    },

    asyUpdataSelectRegionList(context, selectRegionList) {
      context.commit('updataSelectRegionList', selectRegionList)
    },
    asyUpdataOneServeSonAccountData(context, oneServeSonAccountData) {
      context.commit('updataOneServeSonAccountData', oneServeSonAccountData)
    },
    asyUpdatauserPassWord(context, userPassWord) {
      context.commit('updatauserPassWord', userPassWord)
    },
    asyUpdataCuserPassWord(context, CuserPassWord) {
      context.commit('updataCuserPassWord', CuserPassWord)
    },
    asyUpdataoneHostData(context, oneHostData) {
      context.commit('updataoneHostData', oneHostData)
    },
    asyUpdataoneHostDeviceListData(context, oneHostDeviceListData) {
      context.commit('updataoneHostDeviceListData', oneHostDeviceListData)
    },
    asyUpdataPanelExtensionThirdPanelListData(
      context,
      panelExtensionThirdPanelListData
    ) {
      context.commit(
        'updataPanelExtensionThirdPanelListData',
        panelExtensionThirdPanelListData
      )
    },
    asyUpdataServeOneObjectinfo(context, ServeOneObjectinfo) {
      context.commit('updataServeOneObjectinfo', ServeOneObjectinfo)
    },
    asyUpdataServeOneObjectRegioninfo(context, ServeOneObjectinfo) {
      context.commit('updataServeOneObjectRegioninfo', ServeOneObjectinfo)
    },
    asyUpdataServeOneObjectIconinfo(context, ServeOneObjectinfo) {
      context.commit('updataServeOneObjectIconinfo', ServeOneObjectinfo)
    },
    asyUpdataserveOneCycTask027Data(context, serveOneCycTask027Data) {
      context.commit('updataserveOneCycTask027Data', serveOneCycTask027Data)
    },
    asyUpdataserveOneLoopTask027Data(context, serveOneLoopTask027Data) {
      context.commit('updataserveOneLoopTask027Data', serveOneLoopTask027Data)
    },
    asyUpdatabindHostState(context, bindHostState) {
      context.commit('updatabindHostState', bindHostState)
    },
    asyUpdataconfig019PageData(context, config019PageData) {
      context.commit('updataconfig019PageData', config019PageData)
    },
    asyUpdataconfig023ShowDataText(context, config023ShowDataText) {
      context.commit('updataconfig023ShowDataText', config023ShowDataText)
    },
    asyUpdataobjectMoveState(context, objectMoveState) {
      context.commit('updataobjectMoveState', objectMoveState)
    }
  },
  modules: {}
}

export default configinfo
